import { render, staticRenderFns } from "./SystemPermissionGroupManageByRentalcompany.vue?vue&type=template&id=32ad5170&scoped=true"
import script from "./SystemPermissionGroupManageByRentalcompany.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupManageByRentalcompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad5170",
  null
  
)

export default component.exports